import { Link } from 'gatsby'
import React from 'react'
import logo from '../../images/logo.png'

class Navi extends React.Component {
  render() {
    const { location, title } = this.props
    return (
      <header id="header" className="header header-transparent">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="SRE NEXT" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="icon icon-menu" />
              </span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link to="/#about">About</Link>
                </li>
                <li className="nav-item">
                  <Link to="/speakers">Speakers</Link>
                </li>
                <li className="nav-item">
                  <Link to="/schedule">Schedule</Link>
                </li>
                <li className="nav-item">
                  <Link to="/videos">Videos</Link>
                </li>
                <li className="nav-item">
                  <Link to="/#sponsors">Sponsors</Link>
                </li>
                <li className="nav-item">
                  <Link to="/#venue">Venue</Link>
                </li>
                <li className="nav-item">
                  <Link to="/#coc">Code of Conduct</Link>
                </li>
                <li className="nav-item">
                  <Link to="/#team">Team</Link>
                </li>
                <li className="nav-item">
                  <a href="https://blog.sre-next.dev/">Blog</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    )
  }
}

export default Navi
